// src/components/DisclaimerDialog.tsx
import React from 'react';
import GameButton from './GameButton';

interface DisclaimerDialogProps {
  onAccept: () => void;
  onDecline: () => void;
}

const DisclaimerDialog: React.FC<DisclaimerDialogProps> = ({ onAccept, onDecline }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'var(--dialog-bg, #fff)',
        color: 'var(--text-normal)',
        borderRadius: '1rem',
        padding: '2rem',
        maxWidth: '650px',
        width: '90%',
        border: '2px solid var(--border-color, #888)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
      }}>
        <h2 style={{ marginBottom: '1rem' }}>Welcome to the Reword Alpha Test</h2>
        <p style={{ marginBottom: '1rem' }}>
        By participating in this early access version of Reword, you agree to the following:
        </p>
        <ul style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
          <li>This game is in alpha and is **by invitation only**.</li> 
          <li>Do not share the game link or any part of the game with others.</li>
          <li>Game mechanics, design, and content are subject to change during development.</li>
          <li>Do not copy, redistribute, or reverse-engineer any part of the game or system.</li>
          <li>Feedback is welcome and appreciated — we’re building something great together!</li>
        </ul>
        <p style={{ marginBottom: '1.5rem' }}>
        Your helping shape the final game. Thank you for being part of this journey.
        </p>
        <div style={{
            display: 'flex',
            justifyContent: 'center', // ✅ center buttons
            gap: '2rem',              // ✅ space between them
            marginTop: '1rem'
            }}>
            <GameButton label="Decline" onClick={onDecline} />
            <GameButton label="Accept" onClick={onAccept} />
        </div>
      </div>
    </div>
  );
};

export default DisclaimerDialog;
